<template>
  <div class="newsPage">
    <!-- <Header activeIndex="/news" /> -->
    <div>
      <img style="width: 100%" src="@/assets/image/newsbanner.png" alt="" />
    </div>
    <div class="pagew mid">
      <el-carousel v-if="hotList.length" height="310px" :interval="count" v-show="false">
        <el-carousel-item v-for="(item, index) in hotList" :key="index">
          <div style="display: flex; justify-content: space-between">
            <div class="lb-text">
              <div class="date">{{ item.date }}</div>
              <div class="text-overflow title">{{ item.title }}</div>
              <div class="mutline content">{{ item.introduce }}</div>
              <a href="javascript:void(0);" class="eye" @click="()=>toPage(item, index)">
                <img src="@/assets/image/eye.png" alt="" />
              </a>
            </div>
            <div class="img" style="width: 500px;height: 281px;overflow: hidden">
              <img v-if="item.photo" :src="`http://admin.gdsme.org/prod-api${item.photo}`" />
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="list">
        <div
          class="list-box"
          v-for="(item, index) in listdata"
          :key="index"
          @click="()=>toPage(item, index)"
        >
          <div class="left-box">
            <div class="day">{{ item.day }}</div>
            <div class="month" v-show="false">{{ item.month }}</div>
            <div class="year">{{ item.year }}-{{ item.month }}</div>
          </div>
          <div class="right-box">
            <div class="title">{{ item.title }}</div>
            <div class="text-overflow content">{{ item.introduce }}</div>
          </div>
        </div>
        <div style="margin-top: 30px">
          <el-pagination
            layout="prev, pager, next" :total="total"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
          ></el-pagination>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header/Header";
import {getNewsList} from "@/api/api.js";
import Footer from "@/components/Footer/index";
import { lbdata } from "./data";

export default {
  // components: { Footer, Header },
  data() {
    return {
      hotList: [],
      listdata:[],
      count: 5000,
      total: 0,
      currentPage: 1
    };
  },
  created() {
    this.getHotList();
    this.getList()
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    getHotList() {
      getNewsList({pageNum: 1, type: '5', pageSize: 4}).then(res=>{
        const { total, rows = [] } = res.data;
        this.hotList = rows
      })
    },
    //  请求新闻列表
    getList(){
      getNewsList({pageNum: this.currentPage, pageSize: 10}).then(res=>{
        const { total, rows = [] } = res.data;
        this.total = total;
        rows.forEach(item=>{
          if(item.createtime&&item.createtime!==''){
            let i = item.createtime.split("-")
            item.day = i[2]
            item.month = i[1]
            item.year = i[0]
          }
        })
        this.listdata = rows;
      })
    },
    go(code) {
      this.index = code;
    },
    toPage(item, index) {
      const { id, title } = item;
      this.$router.push({
        path: "/news/newsdetail",
        query: {
          id,
          title,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.list ::v-deep .el-pagination .el-pager li .active {
  background-color: #dd1f24 !important;
}

.newsPage {
  .mid {
    padding: 40px 0;
  }

  .lb-text {
    width: 600px;
    color: black;
    text-align: start;
    position: relative;
    .date {
      color: rgb(188, 32, 31);
      font-size: 18px;
      margin-bottom: 10px;
    }

    .title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .content {
      line-height: 20px;
      margin-bottom: 20px;
      height: 80px;
      -webkit-line-clamp: 4;text-align: justify;
    }

    .eye {
      width: 100%;
      position: absolute;bottom: 0;
      background: #f8f5f0;
      padding: 10px 0;
      text-align: center;
      img {width: 37px;}
    }
  }

  .list-box {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    // border-top: 1px solid lightgray;
    border-bottom: 1px solid #ececec;
    padding: 30px 0;margin-top: 20px;
    text-align: start;

    .left-box {
      width: 90px;
      padding-left: 20px;
      padding-top: 12px;
      height: 90px;
      background-color: rgb(248, 245, 240);

      .day {
        font-size: 35px;
        color: rgb(4, 79, 166);
      }

      .month,
      .year {
        font-size: 15px;
        color: rgb(139, 138, 136);
      }
    }

    .right-box {
      text-align: start;
      width: 88%;
      padding-top: 20px;

      .title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 25px;
      }
    }
  }

  .list .list-box:first-child {
    border-top: 1px solid lightgray;
  }

  .el-carousel__item h3 {
    color: rgb(217, 2, 17);
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .el-carousel__item .is-active {
    :deep(.is-active) {
      background-color: red;
    }
  }

  .el-carousel__item:nth-child(2n) {
    // background-color: gray;
  }

  .el-carousel__item:nth-child(2n + 1) {
    // background-color: gray;
  }
}
</style>
<style lang="scss">
  .newsPage {
    .el-carousel__button {
      background: #c1c1c1;
    }
    .is-active .el-carousel__button {
      background: #044fa6;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/news/news.vue